class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');
    this.input.addEventListener('click', this.debounce((event) => {
      document.querySelector('body').classList.add('open-search');
      document.querySelector('body').classList.remove('open-second-level','filter-sticky');
    }).bind(this));
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if(input_length>0){
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = false;
        });
      }else{
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = true;
        });
      }
    }, 300).bind(this));
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=8&section_id=predictive-search`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      if(document.getElementById('SearchValue')){
        document.getElementById('SearchValue').value = searchTerm;
      }           
    })
    .catch((error) => {
      this.close();
      throw error;
    });
  }
  open() {
    document.querySelectorAll('.snippet-search-bar').forEach(function(predictiveResult) {
      predictiveResult.classList.add('active-search-results');
    });
  }
  close() {
    document.querySelectorAll('.snippet-search-bar').forEach(function(predictiveResult) {
      predictiveResult.classList.remove('active-search-results');
    });
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
if(document.querySelectorAll('.variant-grid')){
  function quickAddButton(){
    document.querySelectorAll('.variant-grid').forEach(function(sizeList){
      sizeList.addEventListener('click',function(e){
        e.preventDefault();
        let variant_id = sizeList.dataset.id;
        let error_grid_outer = sizeList.closest('.snippet-product-grid');
        let error_grid = error_grid_outer.querySelector('.grid-error');
        let formData = {
          'items': [{
            'id': variant_id,
            'quantity': 1,
            'properties': {
              _unique: `${variant_id}:${Date.now()}:${Math.random().toString(36).substring(2, 15)}`
            }
          }]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
        .then((response) => response.json())
        .then((data) => {
          if(data.status == 422)
          {
            error_grid.innerHTML = data.description;
            setTimeout(function(e){
              error_grid.innerHTML = '';
            },2000);
          }else{          
            if(document.location.href.indexOf('/cart') > -1) {
              window.location.href = "/cart";
            }else{
              if(typeof load_cart == 'function'){
                load_cart();
                setTimeout(function(e){
                  document.querySelector('body').classList.add('open-drawer');
                },500);
              }else{
                window.location.href = "/cart";
              }          
            }
            const url = '/cart.js';
            fetch(url)
            .then((resp) => resp.json())
            .then(function(data) {
              var cart_count = data.item_count;
              if(cart_count>0){
                document.querySelector('.cart-count').innerHTML = cart_count;
              }else{
                document.querySelector('.cart-count').innerHTML = '';
              }
            })
            .catch(function(error) {
              console.log(error);
            })
          }
        })
        .catch((error) => {
          console.error(error);
        });
      });
    });
  }
  quickAddButton();
}
document.onkeydown = function(evt){
  evt = evt || window.event;
  var isEscape = false;
  if("key" in evt){
    isEscape = (evt.key === "Escape" || evt.key === "Esc");
  }else{
    isEscape = (evt.keyCode === 27);
  }
  if(isEscape){
    document.querySelector('body').classList.remove('open-filter','open-sort','open-drawer','open-menu','open-search','active-popup','open-currency');
  }
};
// class LocalizationForm extends HTMLElement {
//   constructor() {
//     super();
//     this.elements = {
//       input: this.querySelector('input[name="country_code"]'),
//       panel: this.querySelector('ul'),
//     };
//     this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
//     this.querySelectorAll('.disclosure ul a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
//   }
//   hidePanel() {
//     this.elements.panel.setAttribute('hidden', true);
//   }
//   onContainerKeyUp(event) {
//     if (event.code.toUpperCase() !== 'ESCAPE') return;
//     this.hidePanel();
//   }
//   onItemClick(event) {
//     event.preventDefault();
//     const form = this.querySelector('form');
//     this.elements.input.value = event.currentTarget.dataset.value;
//     if (form) form.submit();
//   }
//   openSelector() {
//     this.elements.panel.toggleAttribute('hidden');
//   }
//   closeSelector(event) {
//     const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
//     if (event.relatedTarget === null || shouldClose) {
//       this.hidePanel();
//     }
//   }
// }
// customElements.define('localization-form', LocalizationForm);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.currencyLinks = this.querySelectorAll('[data-value]');
    this.languageLinks = this.querySelectorAll('a[href^="#Weglot-"]');
    this.currencyLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const value = link.getAttribute('data-value');
        if (!value) return;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'currency';
        input.value = value;
        this.form.appendChild(input);
        this.form.submit();
      });
    });
    this.languageLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        const href = link.getAttribute('href');
        const match = href.match(/^#Weglot-(.+)/);
        if (match) {
          e.preventDefault();
          const code = match[1];
          if (typeof Weglot !== 'undefined') {
            Weglot.switchTo(code);
          }
        }
      });
    });
  }
}
customElements.define('localization-form', LocalizationForm);


if(__st.p == 'home'){
  var init = false;
  var homeSwiper;
  var intentObserver;
  var preventScroll;
  function swiperCard(){
    if(window.innerWidth <= 991){
      if(homeSwiper){
        homeSwiper.destroy(true, true);
        homeSwiper = null;
      }
      if(!init){
        gsap.registerPlugin(ScrollTrigger);
        let currentNum = 0;
        let animating = false;
        let stopTop = false;
        let swipePanels = gsap.utils.toArray(".home-slider .shopify-section");
        gsap.set(swipePanels, { yPercent: 100 });
        gsap.set(swipePanels[0], { yPercent: 0 });
        intentObserver = ScrollTrigger.observe({
          type: "wheel,touch",
          onUp: () => !animating && gotoPanel(currentNum + 1),
          onDown: () => !animating && gotoPanel(currentNum - 1),
          preventDefault: true
        });
        intentObserver.disable();
        preventScroll = ScrollTrigger.observe({
          preventDefault: true,
          type: "wheel,scroll",
          allowClicks: true,
          onEnable: (self) => (self.savedScroll = self.scrollY()), 
          onChangeY: (self) => self.scrollY(self.savedScroll)
        });
        preventScroll.disable();
        function gotoPanel(index){
          if(index < 0 || animating) return;
          animating = true;
          let isScrollingDown = index > currentNum;
          let currentPanel = swipePanels[currentNum];
          let targetPanel;
          if(index >= swipePanels.length){
            targetPanel = swipePanels[0];
            index = 0;
            gsap.set(swipePanels[swipePanels.length - 2], { yPercent: 100 });
            gsap.set(swipePanels[swipePanels.length - 1], { yPercent: 0 });
            gsap.set(swipePanels[0], { yPercent: 100, zIndex: 1 });
          }else{
            targetPanel = swipePanels[index];
            gsap.set(swipePanels[0], { zIndex: '' });
          }
          if(index === 0){
            document.querySelector('.main-header').classList.remove('sticky_header');
          }else{
            document.querySelector('.main-header').classList.add('sticky_header');
          }
          swipePanels.forEach((panel, i) => {
            if(i === index){
              panel.classList.add('active-slide');
            }else{
              panel.classList.remove('active-slide');
            }
          });
          if(document.querySelector('.stop-to-top.active-slide')){
            stopTop = true;
          }
          gsap.timeline({
            onComplete: () => {
              animating = false;
              currentNum = index;
            }
          })
          .to(currentPanel, {
            yPercent: isScrollingDown ? 0 : 100,
            duration: 0.75
          })
          .to(targetPanel, {
            yPercent: 0,
            duration: 0.75
          }, 0);
          if(!isScrollingDown){
            gsap.set(targetPanel, { yPercent: 0 });
          }
          swipePanels.forEach((panel, i) => {
            if (i !== index && i !== currentNum) {
              gsap.set(panel, { yPercent: 100 });
            }
          });
        }
        ScrollTrigger.create({
          trigger: ".home-slider",
          pin: true,
          anticipatePin: true,
          start: "top top",
          end: "+=50%",
          onEnter: (self) => {
            if(!preventScroll.isEnabled){
              self.scroll(self.start);
              preventScroll.enable();
              intentObserver.enable();
            }
          },
          onEnterBack: (self) => {
            if(!preventScroll.isEnabled){
              self.scroll(self.start);
              preventScroll.enable();
              intentObserver.enable();
            }
          },
        });
        let lastTouchX = 0;
        let lastTouchY = 0;
        
        window.addEventListener("touchstart", (event) => {
          if (event.target.closest('.menu-drawer-inr')) {
            return; // Ignore touchstart events within the .menu-drawer-inr element
          }
          if (event.target.closest('.visual-categories-wrapper')) {
            preventScroll.disable();
            intentObserver.disable();
          }
          const touch = event.touches[0];
          lastTouchX = touch.clientX;
          lastTouchY = touch.clientY;
          if(document.querySelector('.stop-to-top.active-slide')){
            stopTop = false;
          }
        });
        window.addEventListener("touchmove", (event) => {
          if (event.target.closest('.menu-drawer-inr')) {
            return; // Ignore touchmove events within the .menu-drawer-inr element
          }
          if (event.target.closest('.visual-categories-wrapper')) {
            preventScroll.disable();
            intentObserver.disable();
          }
          const touch = event.touches[0];
          const deltaX = touch.clientX - lastTouchX;
          const deltaY = touch.clientY - lastTouchY;
          if(Math.abs(deltaX) > Math.abs(deltaY)){
            preventScroll.disable();
            intentObserver.disable();
            return;
          }else{
            if(document.querySelector('.stop-to-top.active-slide') && stopTop){
              preventScroll.disable();
              intentObserver.disable();
            }else{
              preventScroll.enable();
              intentObserver.enable();
              const scrollDirection = deltaY < 0 ? 1 : -1;
              gotoPanel(currentNum + scrollDirection);
            }
          }
          lastTouchX = touch.clientX;
          lastTouchY = touch.clientY;
        });
        init = true;
      }
    }else{
      if(intentObserver){
        intentObserver.kill();
        intentObserver = null;
      }
      if(preventScroll){
        preventScroll.kill();
        preventScroll = null;
      }
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
      if(!homeSwiper){
        homeSwiper = new Swiper(".home-slider", {
          direction: "vertical",
          loop: true,
          mousewheel:{
            forceToAxis: true,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            hide: true,
          },
          speed: 1000,
          slidesPerView: 'auto',
          spaceBetween: 0,
          on: {
            init: function (e){
              let isAtFirstSlide = e.realIndex === 0;
              e.allowSlidePrev = !isAtFirstSlide;
            },
          }
        });
        homeSwiper.on('slideChange', function(){
          if(homeSwiper.isBeginning == false){
            document.querySelector('.main-header').classList.add('sticky_header');
            let isAtFirstSlide = homeSwiper.realIndex === 0;
            homeSwiper.allowSlidePrev = !isAtFirstSlide;
          }
        });
      }
      init = false;
    }
  }
  swiperCard();
  window.addEventListener("resize", swiperCard);
}
document.addEventListener("DOMContentLoaded", () => {
  fetch("https://ipapi.co/json/")
    .then(response => response.json())
    .then(data => {
      let countryCode = data.country?.toLowerCase();
      if(localStorage.getItem('Language') != null){
        countryCode = localStorage.getItem('Language');
      }
      console.log(data, 'data',countryCode);
      let linkSelector = `.md-lang-curr-inr[data-name="language"] .disclosure__list .disclosure__item .weglot-link-${countryCode}`;
      let linkElement = document.querySelector(linkSelector);
      if(linkElement){
        linkElement.click();
      }else{
        document.querySelector('.md-lang-curr-inr[data-name="language"] .disclosure__list .disclosure__item .weglot-link-en').click();
      }
    })
    .catch(err => {
      console.error("Geo IP lookup failed:", err);
    });
});